import PropTypes from 'prop-types';
import actionsSims from '../../api/actionsSims';
import { nsSimCard } from '@/app/i18n/namespaces';
import Select from '@/common-utils/components/ui/select';
import Entity from '@/common-utils/components/renders/entity/Entity';
import { Skeleton } from '@/common-utils/components/ui/skeleton';
import { useEffect } from 'react';


/**
 *
 * @param root0
 * @param root0.selectedOffer
 * @param root0.setSelectedOffer
 * @param root0.selectedProvider
 * @param root0.setSelectedProvider
 * @param root0.simProviders
 * @param root0.setSelectedOfferName
 * @param root0.isLoading
 * @returns {JSX} CustomPaySelectOffer
 */
function CustomPaySelectOffer({
    selectedProvider,
    setSelectedProvider,
    simProviders,
    isLoading,
    selectedOffer = null,
    setSelectedOffer = null,
    setSelectedOfferName = null
}) {

    // Api calls
    const { data: offersData, isFetching, isError, refetch } = actionsSims.getSimPayviewOffers(selectedProvider, false);

    // Hooks
    useEffect(() => {
        if (selectedProvider && setSelectedOffer && setSelectedOfferName) {
            refetch();
        }
    }, [selectedProvider, setSelectedOffer, setSelectedOfferName]);

    useEffect(() => {
        if (isFetching && setSelectedOffer && setSelectedOfferName) {
            setSelectedOffer('');
            setSelectedOfferName('');
        }
    }, [isFetching, setSelectedOffer, setSelectedOfferName]);

    return (
        <div className='my-4'>
            {
                simProviders &&
                <>
                    {
                        isLoading &&
                        <>
                            <Skeleton className='w-40 h-6 my-2' />
                            <Skeleton className='w-full h-8' />
                        </>
                    }
                    {
                        !isLoading &&
                        <>
                            <div>
                                <Entity entity='modal.multiple_activation.provider.label' namespace={nsSimCard} />
                            </div>
                            <Select
                                value={selectedProvider}
                                options={simProviders}
                                onChange={(value) => setSelectedProvider(value)}
                                namespace={nsSimCard}
                                placeholder='modal.order_sim.form.provider_placeholder'
                            />
                        </>
                    }
                    {
                        isFetching &&
                        <>
                            <Skeleton className='w-40 h-6 my-2' />
                            <Skeleton className='w-full h-8' />
                        </>
                    }
                    {
                        !isFetching && isError &&
                        <Entity entity='modal.custom_pay_multiple_activation.error_offers' namespace={nsSimCard} />
                    }
                    {
                        !isFetching
                        && selectedOffer !== null
                        && setSelectedOffer !== null
                        && setSelectedOfferName !== null
                        && offersData
                        && selectedProvider !== ''
                        &&
                        <>
                            <div className='mt-2'>
                                <Entity entity='modal.custom_pay_multiple_activation.labels.offer' namespace={nsSimCard} />
                            </div>
                            <Select
                                value={selectedOffer.value}
                                options={offersData.map((item) => ({ value: item.uuid, name: item.name }))}
                                onChange={(value) => {
                                    setSelectedOffer(value);
                                    setSelectedOfferName(offersData.find((item) => item.uuid === value).name);
                                }}
                                namespace={nsSimCard}
                            />
                        </>
                    }
                </>
            }
        </div >
    );
}

CustomPaySelectOffer.propTypes = {
    selectedOffer: PropTypes.string,
    setSelectedOffer: PropTypes.func,
    setSelectedOfferName: PropTypes.func,
    selectedProvider: PropTypes.string,
    setSelectedProvider: PropTypes.func,
    simProviders: PropTypes.array,
    isLoading: PropTypes.bool
};

export default CustomPaySelectOffer;